<div (click)="media.toggleMute()" class="icon">
  <ng-container *ngIf="!media.mute else mute">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.6044 4.40625L7.11512 9.15409H1.91992V15.2639H7.0364L12.6044 20.0802V4.40625Z" fill="#8C8E9B"
        stroke="#8C8E9B" stroke-width="1.6" stroke-linejoin="round" />
      <path
        d="M15.3604 8.83247C16.028 9.84963 16.3837 11.0398 16.3837 12.2565C16.3837 13.4732 16.028 14.6633 15.3604 15.6805M17.6324 6.56047C18.8486 8.21053 19.5048 10.2066 19.5048 12.2565C19.5048 14.3063 18.8486 16.3024 17.6324 17.9525M19.7124 4.48047C21.4835 6.68517 22.4489 9.42845 22.4489 12.2565C22.4489 15.0845 21.4835 17.8278 19.7124 20.0325"
        stroke="#8C8E9B" stroke-width="1.6" stroke-linecap="round" />
    </svg>
  </ng-container>
  <ng-template #mute>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.4799 4.48047L7.03992 9.28047H1.91992V15.3605H7.03992L12.4799 20.1605V4.48047Z" fill="#8C8E9B"
        stroke="#8C8E9B" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M15.6797 8.32031L22.0797 16.0003M22.0797 8.32031L15.6797 16.0003" stroke="#8C8E9B" stroke-width="1.6"
        stroke-linecap="round" />
    </svg>
  </ng-template>
</div>